import { Component, Input, ChangeDetectionStrategy } from '@angular/core'

import { MenuDropdown } from '@app-domains/navigation/menu-dropdown/menu-dropdown'
import { AuthService } from '@app-services'

@Component({
    selector: 'app-auth-header',
    templateUrl: './auth-header.component.html',
    styleUrls: ['./auth-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class AuthHeaderComponent {

    @Input()
    public authVersion: 'mobile' | 'desktop' = 'desktop'

    @Input()
    public mobileMenuIsOpen: boolean

    @Input()
    public userDropdown: MenuDropdown

    constructor(
        public readonly authService: AuthService,
    ) {
    }
}
